import React from 'react';
import PropTypes from 'prop-types';
import { ModalLink } from 'components/core/ModalLink';
import { Text } from 'components/core/Typography';
import { Image } from 'components/core/Image';
import { QuestionMark } from 'components/svg';
import GiftCardModal from 'components/giftcard/GiftCardModal/GiftCardModal';
import stuffBinoculars from 'assets/images/stuffs/stuff-binoculars.svg';

import './GiftCardModalLink.scss';

const GiftCardModalLink = ({ showTopText, modalText }) => {
	return (
		<>
			<div className="gift-card-dollar-amount">$20</div>
			<div className="gift-card-modal-link-container-text">
				{showTopText && (
					<Text
						size="tiny"
						color="white"
						last
					>
						AVAILABLE FOR SELECT UNIT RENTALS
					</Text>
				)}
				<ModalLink
					size="standard"
					family="rounded"
					Icon={<QuestionMark opacity />}
					text={
						modalText
							? modalText
							: 'Reserve, then complete your rental online for a Visa Gift Card'
					}
					content={<GiftCardModal />}
				/>
			</div>
			<Image
				className="gift-card-modal-link-stuff-binoculars"
				src={stuffBinoculars}
				alt="stuff binoculars"
			/>
		</>
	);
};

GiftCardModalLink.PropTypes = {
	showTopText: PropTypes.bool,
	modalText: PropTypes.string,
};

export default GiftCardModalLink;